import { Routes, Route, Navigate } from 'react-router-dom';
import ReceptionLayout from './ReceptionLayout';
import ReceptionDashboard from './ReceptionDashboard';
import ReceptionAppointments from './ReceptionAppointments';
import ReceptionCheckIn from './ReceptionCheckIn';
import ReceptionPatients from './ReceptionPatients';
import ReceptionInvoicing from './ReceptionInvoicing';
import ReceptionPayments from './ReceptionPayments';
import ReceptionCommunications from './ReceptionCommunications';
import ReceptionReports from './ReceptionReports';
import ReceptionSettings from './ReceptionSettings';
import ReceptionUnmatchedLabResults from './ReceptionUnmatchedLabResults';

export default function ReceptionRouter() {
  return (
    <Routes>
      <Route element={<ReceptionLayout />}>
        <Route path="" element={<ReceptionDashboard />} />
        <Route path="overview" element={<ReceptionDashboard />} />
        <Route path="dashboard" element={<Navigate to="../" replace />} />
        <Route path="appointments" element={<ReceptionAppointments />} />
        <Route path="check-in" element={<ReceptionCheckIn />} />
        <Route path="patients" element={<ReceptionPatients />} />
        <Route path="unmatched-lab-results" element={<ReceptionUnmatchedLabResults />} />
        <Route path="invoicing" element={<ReceptionInvoicing />} />
        <Route path="payments" element={<ReceptionPayments />} />
        <Route path="communications" element={<ReceptionCommunications />} />
        <Route path="reports" element={<ReceptionReports />} />
        <Route path="settings" element={<ReceptionSettings />} />
      </Route>
    </Routes>
  );
}

